import { create } from 'zustand';

export interface IDemoInsightsStore {
  isOpenModalDemo: boolean;
  setIsOpenModalDemo: (isOpenModal: boolean) => void;
}

export const useDemoInsightsStore = create<IDemoInsightsStore>((set) => ({
  isOpenModalDemo: false,
  setIsOpenModalDemo: (isOpenModalDemo) => set({ isOpenModalDemo }),
}));
